/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function desktopFiltersDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            'activeFilters': '=',
            'facets': '=',
            'activeCategory': '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: desktopFilters,
        template: require('./desktopFiltersView.html')
    };
}

desktopFilters.$inject = [
    '$filter',
    '$window',
    'FiltersService',
    'UtilService',
    'CmsContentService'
];
function desktopFilters(
    $filter,
    $window,
    FiltersService,
    UtilService,
    CmsContentService
) {

    this.$onInit = () => {
        const vm = this;
        vm.resetFilters = resetFilters;
        vm.getFilterInputType = FiltersService.getFilterInputType;
        vm.isCheckboxFilter = FiltersService.isCheckboxFilter;
        vm.filterResults = FiltersService.filterResults;
        vm.sideAdTagName = UtilService.getSiteSetting('sidebar_ad_tag_name', 'DSK-CAT-BF-S1');

        FiltersService.lockFilters = true;

        CmsContentService.retrieveCMSContent('filters');

        vm.isEnabled = shouldShow();

        angular.element($window).bind('resize', () => {
            FiltersService.lockFilters = false;
            if (vm.isEnabled && !shouldShow()) {
                vm.isEnabled = false;
            }
            if (!vm.isEnabled && shouldShow()) {
                vm.isEnabled = true;
            }
        });

        /**
         * Toggle the filter sidebar (new filters)
         */
        vm.collapseSidebar = () => {
            FiltersService.trackCollapsedFiltersEngaged();
            vm.isSidebarCollapsed = true;
            $('.has-sidebar').addClass('sidebar-collapsed');
        };

        vm.expandSidebar = () => {
            vm.isSidebarCollapsed = false;
            $('.has-sidebar').removeClass('sidebar-collapsed');
        };

        vm.toggleSidebar = () => {
            if (vm.isSidebarCollapsed) {
                vm.expandSidebar();
            } else {
                vm.collapseSidebar();
            }
        };

        // If gas water heater and if it's enabled for the site
        const GAS_WATER_HEATER_ID = 61;
        vm.isLowNoxEnabled = UtilService.isFeatureEnabled('low_nox') && vm.activeCategory.id === GAS_WATER_HEATER_ID;

    };

    function resetFilters() {
        FiltersService.resetFilters();
    }

    /**
     * Determines whether or not we should show the desktops's new filters
     *
     * @returns {boolean} Whether or not we should show the desktop's new filters
     */
    function shouldShow() {
        return !UtilService.isMobile() && FiltersService.isNewFiltersEnabled;
    }

}

module.exports = desktopFiltersDirective;
